export default "__VITE_ASSET__BP5G_b_V__"